(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.config(deliveryScoreTrendConfig);

	function deliveryScoreTrendConfig(dashboardProvider) {
		// register widget
		dashboardProvider
			.widget('deliveryScoreTrend',
				{
					name: 'Delivery Score Trend',
					description: 'Monthly supplier delivery performance and rolling 3-month average over the last 12 months.',
					thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/PPVGraph.png',
					categories: ['All', 'Supplier Performance'],
					config: {},
					slideshowView: true,
					isActive: true,
					controller: 'deliveryScoreTrendCtrl',
					templateUrl: '/application/f/dashboard/widgets/delivery-score-trend.html',
					reload: true,
					isDrillDown: false
				}
			);
	}
})();
